/**
 *
 * CongratsComponent
 *
 */
import React, { memo, useEffect, useState } from 'react';
import styled from 'styled-components/macro';
import { useTranslation } from 'react-i18next';
import Congrats from './congrats.svg';
import Goal from './goal.svg';
import { useGoalPlanner } from 'app/Provider/GoalPlannerProvider';
import { Button } from '../Button';
import { media } from 'styles/media';
import Confetti from 'react-confetti';
import { useNavigate } from 'react-router-dom';
interface Props {
  boxText: string;
  id?: string;
}

export const CongratsComponent = memo((props: Props) => {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const [confetti, setConfetti] = useState<boolean>(false); // State to control confetti
  const { isModalOpen, toggleModal } = useGoalPlanner();

  // Effect to handle confetti on modal open
  useEffect(() => {
    if (isModalOpen) {
      setConfetti(true); // Start confetti when modal is open

      // Stop confetti after 5 seconds
      const confettiTimeout = setTimeout(() => {
        setConfetti(false); // Stop confetti after timeout
      }, 5000); // 5000ms = 5 seconds

      return () => clearTimeout(confettiTimeout); // Cleanup timeout if the modal is closed before 5 seconds
    }
  }, [isModalOpen]);
  return (
    <>
      {isModalOpen && (
        <Div
          className="modal show  d-flex justify-content-center align-items-center  h-100 w-100   "
          tabIndex={-1}
          role="dialog"
        >
          {confetti && <Confetti />}
          <Box className="bg-white d-flex flex-column gap-3 px-4 py-3">
            <div className="d-flex justify-content-end ">
              <Circle
                className="bg-primary rounded-5 d-flex justify-content-center text-white h6 align-items-center "
                onClick={toggleModal}
              >
                X
              </Circle>
            </div>
            <div className="d-flex justify-content-center px-5 ">
              <div className="d-flex flex-column align-items-center border-bottom  gap-4 w-100 ">
                <img src={Congrats} alt="" />
                <Heading>
                  Congrats! <Span>You have a plan now</Span>
                </Heading>
              </div>
            </div>

            {/* <Paragraph className="text-center">
              Here is the summary of your goal...
            </Paragraph> */}
            <Container className="d-flex justify-content-center align-items-center mt-4 py-3 px-5">
              <div className="d-flex align-items-start gap-2 ">
                <Box1 className="d-flex flex-row align-items-center gap-2">
                  <img src={Goal} alt="" />
                  <MainText>{props.boxText}</MainText>
                </Box1>
              </div>
            </Container>
            {/* <BorderDashed className="mx-5"></BorderDashed> */}
            <Description className="mx-5 py-3">
              I plan to retire at <DescriptionSpan>65</DescriptionSpan> with{' '}
              <DescriptionSpan>₹8</DescriptionSpan>
              Crores saved, allowing for a{' '}
              <DescriptionSpan>
                {' '}
                monthly withdrawal of ₹2 Lakhs,
              </DescriptionSpan>{' '}
              adjusted for a 4% annual inflation. To reach this goal, I will
              save{' '}
              <DescriptionSpan>
                {' '}
                ₹50,000 monthly, increasing savings by 5% each year,
              </DescriptionSpan>{' '}
              invested across diverse assets to ensure growth and stability.
            </Description>
            <div className="d-flex justify-content-center align-items-center h-100 gap-3">
              <Button
                variant="#8276F4"
                onClick={() => navigate(`/goalDetails/${props.id}`)}
              >
                Track my goal
              </Button>
              {/* <Button
                variant="#8276F4"
                titleColor="#F3F1FE"
                onClick={toggleModal}
              >
                Allocate assets
              </Button> */}
            </div>
          </Box>
        </Div>
      )}
    </>
  );
});
const Box1 = styled.div`
  width: 413px;
  height: 57px;
  gap: 0px;
  border: 1px solid #c6c0fa;
  border-radius: 10px;
  padding-left: 20px;
`;
const Box = styled.div`
  width: 950px;
  height: 675px;
  border-radius: 20px;
`;
const Container = styled.div`
  ${media.small} {
    flex-direction: column;
  }
`;
const Div = styled.div`
  height: 675px;
  width: 950px;
  background: rgba(0, 0, 0, 0.7);
`;
const Circle = styled.div`
  height: 24px;
  width: 24px;
  cursor: pointer;
`;
const Heading = styled.h3`
  font-size: 32px;
  font-weight: 800;
  ${media.small} {
    font-size: 15px;
  }
`;
const Span = styled.span`
  font-size: 32px;
  font-weight: 200;
  ${media.small} {
    font-size: 14px;
  }
`;
const Description = styled.h5`
  font-size: 16px;
  font-weight: 400;
  ${media.small} {
    font-size: 13px;
    text-align: justify;
  }
`;
const DescriptionSpan = styled.span`
  font-size: 16px;
  font-weight: 700;
  ${media.small} {
    font-size: 13px;
  }
`;
const MainText = styled.h2`
  font-size: 20px;
  font-weight: 400;
  ${media.small} {
    font-size: 15px;
  }
  color: #c8ccd8;
  margin: 0;
`;
